import { Box, Hidden } from "@mui/material";
import { ReactComponent as CloseIcon } from "../assets/images/close.svg";
import { ReactComponent as LogoIcon } from "../assets/images/logo.svg";
import {
  StepRoot,
  CloseRow,
  CloseButton,
  StepBody,
  StepTitle,
  StepSubtitle,
  FieldGroup,
  PrimaryButton,
} from "./ForgottenPasswordStyles";

const ForgottenPasswordSuccessStep = ({ close }) => {
  return (
    <StepRoot>
      <CloseRow>
        <CloseButton onClick={close}>
          <CloseIcon />
        </CloseButton>
      </CloseRow>

      <StepBody>
        <StepTitle>הסיסמה שונתה בהצלחה</StepTitle>
        <StepSubtitle>חזור למסך הכניסה כדי להתחבר</StepSubtitle>

        <FieldGroup sx={{ marginBottom: 0 }}>
          <PrimaryButton onClick={close} variant="contained">
            חזור להתחברות
          </PrimaryButton>
        </FieldGroup>
      </StepBody>

      <Hidden mdUp>
        <Box sx={{ textAlign: "center", pb: "28px", "& svg": { height: "34px" } }}>
          <LogoIcon />
        </Box>
      </Hidden>
    </StepRoot>
  );
};

export default ForgottenPasswordSuccessStep;
